// src/ProfileSecurity.jsx
import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

export default function ProfileSecurity() {
  const { t: translate } = useTranslation();
  const API_URL = process.env.REACT_APP_API_URL;

  const [email, setEmail] = useState('');
  const [step, setStep] = useState(1);
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  async function sendCode() {
    setError('');
    setMsg('');

    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setMsg(translate('profile.security.codeSent'));
      setStep(2);
    } catch (requestError) {
      setError(
        requestError.response?.data?.error ||
          translate('profile.common.error')
      );
    }
  }

  async function resetPassword() {
    setError('');
    setMsg('');

    try {
      await axios.post(`${API_URL}/api/auth/reset-password`, {
        email,
        code,
        newPassword,
      });

      setMsg(translate('profile.security.passwordUpdated'));
      setStep(3);
    } catch (requestError) {
      setError(
        requestError.response?.data?.error ||
          translate('profile.common.error')
      );
    }
  }

  const inputStyle = {
    padding: 10,
    width: 'min(100%, 320px)',
    background: '#020617',
    color: '#e5e7eb',
    border: '1px solid #374151',
    borderRadius: 10,
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    marginTop: 15,
    padding: '10px 20px',
    border: 0,
    borderRadius: 10,
    background: '#c9a15a',
    color: '#111827',
    fontWeight: 700,
    cursor: 'pointer',
  };

  return (
    <div style={{ padding: 20, maxWidth: 720 }}>
      <h2>{translate('profile.security.title')}</h2>

      {step === 1 && (
        <>
          <p>{translate('profile.security.enterEmail')}</p>

          <input
            type="email"
            placeholder={translate('profile.security.emailPlaceholder')}
            style={inputStyle}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />

          <br />

          <button type="button" style={buttonStyle} onClick={sendCode}>
            {translate('profile.security.sendCode')}
          </button>
        </>
      )}

      {step === 2 && (
        <>
          <p>{translate('profile.security.enterCodeAndPassword')}</p>

          <input
            type="text"
            placeholder={translate('profile.security.codePlaceholder')}
            style={{ ...inputStyle, letterSpacing: 2 }}
            value={code}
            onChange={(event) => setCode(event.target.value)}
          />

          <br />
          <br />

          <input
            type="password"
            placeholder={translate(
              'profile.security.newPasswordPlaceholder'
            )}
            style={inputStyle}
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
          />

          <br />

          <button type="button" style={buttonStyle} onClick={resetPassword}>
            {translate('profile.security.changePassword')}
          </button>
        </>
      )}

      {step === 3 && (
        <h3 style={{ color: '#4ade80' }}>
          {translate('profile.security.passwordChanged')} ✔
        </h3>
      )}

      {msg && (
        <div style={{ color: '#4ade80', marginTop: 10 }}>{msg}</div>
      )}

      {error && (
        <div style={{ color: '#f87171', marginTop: 10 }}>{error}</div>
      )}
    </div>
  );
}
